import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'
import { ApplicationPipelineReportResponse } from '~bank-reports/types/ApplicationPipelineReport'

type ApplicationPipelineReportContextValue = {
  data: ApplicationPipelineReportResponse
  isFetching: boolean
  routeApi: RouteApi<'/_app/reports/application-pipeline', AnyRouter>
}

export const ApplicationPipelineReportContext = createContext<ApplicationPipelineReportContextValue | null>(null)

export const useApplicationPipelineReportContext = () => {
  const context = useContext(ApplicationPipelineReportContext)
  if (!context) {
    throw new Error(
      'useApplicationPipelineReportContext must be used within a ApplicationPipelineReportContext.Provider'
    )
  }
  return context
}
